<template>
  <section
    class="text-center container col-lg-8 col-md-9 col-sm-10 mx-auto mt-2 mb-4"
  >
    <h1 class="animate-characters my-4">The Surviville Card Game</h1>

    <template v-if="remainingCards > 0">
      <h3>
        For {{ bchPerCardE13 / 10 ** 5 }} {{ ETH }} or
        {{ tokenPerCardE15["svc"] / 10 ** 3 }} SVC you can play 1 card for a
        chance to win
        {{
          Math.ceil(
            5000 /
              ((100 - getDiscount4Reapers(stakingPower)) *
                (tokenPerCardE15["svc"] / 10 ** (2 + 3 + 2)))
          )
        }}% of your investment.
      </h3>

      <template v-if="stakingPower > discounts[2]">
        <h3 class="animate-characters mt-4">
          You qualify for a {{ getDiscount4Reapers(stakingPower) }}% discount
        </h3>
        <h3>
          You save
          {{
            (50 * getDiscount4Reapers(stakingPower) * bchPerCardE13) / 10 ** 7
          }}
          {{ ETH }} or
          {{
            (50 * getDiscount4Reapers(stakingPower) * tokenPerCardE15["svc"]) /
            10 ** 5
          }}
          SVC for every 50 cards you play.
        </h3>
      </template>
      <h4 class="mt-4" v-else>
        Stake Reaperville NFTs to get a discount of up to
        {{ discounts[discounts.length - 1] }}%.
      </h4>

      <h4 v-if="!show['discountDetails']" class="mb-4">
        Learn more about discounts &nbsp;
        <a href="#DiscountDetails"
          ><i
            @click="show['discountDetails'] = !show['discountDetails']"
            title="Show table"
            class="ri-mail-line"
          ></i>
        </a>
      </h4>

      <template v-else>
        <h4 id="DiscountDetails" class="my-0">
          Discounts for Reaperville NFT stakers &nbsp;
          <a href="#DiscountDetails"
            ><i
              @click="show['discountDetails'] = !show['discountDetails']"
              title="Hide text"
              class="ri-mail-open-line"
            ></i
          ></a>
        </h4>
        <table class="mx-auto" style="width: 100%">
          <tr>
            <th style="width: 50%">Reaperville Staking Power</th>
            <th style="width: 50%">Discount per Card</th>
          </tr>
          <tr v-for="idx in discounts.length" :key="idx">
            <td v-if="idx % 2 === 1">
              {{ formatNumber(discounts[idx - 1] * 1000, 0) }}
            </td>
            <td v-if="idx % 2 === 1">{{ discounts[idx] }}%</td>
          </tr>
        </table>
        <div class="mb-4">
          <p>
            The NFTs need to be staked when you play the game for the discount
            to be activated.
          </p>
          <h5 class="mb-4">
            Your Reaperville staking power is
            {{ formatNumber(stakingPower, 0) }}.
          </h5>
        </div>
      </template>

      <h3 class="animate-characters">
        Every card has a chance to win 5,000 SVC!
      </h3>
      <h4 v-if="!show['winningChances']">
        Detailed winning chances &nbsp;
        <a href="#WinningChances"
          ><i
            @click="show['winningChances'] = !show['winningChances']"
            title="Show text"
            class="ri-mail-line"
          ></i>
        </a>
      </h4>

      <template v-else>
        <h4 id="WinningChances" class="mt-4">
          Detailed winning chances &nbsp;
          <a href="#WinningChances"
            ><i
              @click="show['winningChances'] = !show['winningChances']"
              title="Hide text"
              class="ri-mail-open-line"
            ></i
          ></a>
        </h4>
        <table class="mx-auto my-4" style="width: 100%">
          <tr>
            <th style="width: 50%">Payout in SVC</th>
            <th style="width: 50%">Slots</th>
          </tr>
          <tr>
            <td>5,000</td>
            <td>1</td>
          </tr>
          <tr>
            <td>2,500</td>
            <td>2</td>
          </tr>
          <tr>
            <td>1,000</td>
            <td>3</td>
          </tr>
          <tr>
            <td>500</td>
            <td>5</td>
          </tr>
          <tr>
            <td>250</td>
            <td>10</td>
          </tr>
          <tr>
            <td>200</td>
            <td>25</td>
          </tr>
          <tr>
            <td>150</td>
            <td>200</td>
          </tr>
          <tr>
            <td>125</td>
            <td>301</td>
          </tr>
          <tr>
            <td>0</td>
            <td>669</td>
          </tr>
        </table>
      </template>

      <h4 class="lead text-muted mx-auto my-3">
        <span>You can play up to 50 cards per transaction. </span>
        <span>
          Every card is drawn in a non-sequential, randomised order.
        </span>
        <span>
          Once a card is drawn, it is not put back into the card pool.
        </span>
      </h4>

      <h2 class="mx-auto my-4" id="cardsPlayed">
        <span>
          {{ totalCards - remainingCards }} of {{ totalCards }} cards have been
          played.
        </span>
        <a href="#cardsPlayed">
          <i title="Reload numbers" v-if="txInProgress" class="ri-refresh-fill">
          </i>
          <i
            title="Reload numbers"
            v-else
            @click="load()"
            class="ri-refresh-fill"
          >
          </i>
        </a>
      </h2>

      <h4 class="lead text-muted mx-auto my-3">
        <span> Please select how many Surviville cards you want to play. </span>
      </h4>

      <div class="mb-3 mx-auto">
        <div class="input-group mx-auto">
          <div class="input-group-prepend mx-auto">
            <button
              v-for="_cards in [1, 5, 10, 15, 20, 30, 40, 50]"
              :key="_cards"
              class="btn btn-std"
              type="button"
              @click="setCards2Play(_cards)"
            >
              {{ _cards }}
            </button>
          </div>
        </div>
      </div>

      <div class="mb-3 mx-auto">
        <div class="input-group mx-auto">
          <div class="input-group-prepend mx-auto">
            <button
              class="btn btn-std"
              :disabled="cards2Play <= 1"
              @click="changeCards2Play(-1)"
            >
              -
            </button>

            <div class="col-lg-8 col-md-8 col-sm-8 mx-auto">
              <input
                id="tokensToBuy"
                type="number"
                min="1"
                :max="maxCardsPerTx"
                class="form-control mx-auto"
                @change="changeCards2Play(0)"
                v-model="cards2Play"
              />
            </div>

            <button
              class="btn btn-std"
              :disabled="cards2Play >= maxCardsPerTx"
              @click="changeCards2Play(1)"
            >
              +
            </button>
          </div>
        </div>
      </div>

      <span class="row-lg-12">
        <span class="column">
          <h4 v-if="cards2Play > 1">Play {{ cards2Play }} cards for:</h4>
          <h4 v-else>Play 1 card for:</h4>
          <div class="col-lg-6 col-md-8 mx-auto">
            <button
              id="buyButtonBch"
              type="button"
              class="btn btn-std my-2 btn-large"
              :disabled="contractPaused || bchPerCardE13 <= 0"
              @click="playWithBCH"
            >
              {{
                (cards2Play *
                  bchPerCardE13 *
                  (100 - getDiscount4Reapers(stakingPower))) /
                10 ** 7
              }}
              {{ ETH }}
            </button>
            &nbsp;
            <button
              id="buyButtonSvc"
              type="button"
              class="btn btn-std my-2 btn-large"
              :disabled="contractPaused || tokenPerCardE15['svc'] <= 0"
              @click="playWithToken('svc')"
            >
              {{
                (cards2Play *
                  tokenPerCardE15["svc"] *
                  (100 - getDiscount4Reapers(stakingPower))) /
                10 ** 5
              }}
              SVC
            </button>
            <!-- &nbsp;
            <button
              id="buyButtonFlexUsd"
              type="button"
              class="btn btn-std my-2 btn-large"
              :disabled="mintPaused || powTokenPriceFlexUsd <= 0"
              @click="buyPowWithToken('flexUSD')"
            >
              {{
                formatNumber((nftsToMint * powTokenPriceFlexUsd) / 10 ** 18, 6) 
              }}
              flexUSD
            </button> -->
          </div>
        </span>
      </span>
    </template>
    <template v-else>
      <h2 class="mt-4">
        All cards have been played! Please wait for the next round!
      </h2>
    </template>

    <br />

    <h3 class="mt-4">
      <span>
        Your Balances:
        {{ formatNumber(playersBchBalanceE0 / 10 ** 18, 3) }} {{ ETH }},
        {{ formatNumber(playersBalanceE0["svc"] / 10 ** 18, 3) }}
        SVC
        <!-- {{ formatNumber(stakersFlexUsdBalance / 10 ** 18, 3) }}
              flexUSD -->
      </span>
    </h3>

    <br />

    <h6 class="mx-auto text-muted">
      <span> Note that the transactions cannot be undone. </span>
    </h6>

    <br />

    <h6 class="mx-auto text-muted">
      <span>
        For increased efficiency all cards need to be played directly upon
        purchase and cannot be played at a later point in time.
      </span>
      <span> All winnings are paid out immediately. </span>
    </h6>

    <!-- <br />
    <div class="row py-5">
      <div>
        <h4 class="fw-light">
          <strong> SVC Token Allowance for the Card Game </strong>
        </h4>

        <div class="text-muted">
          <span>
            Before you can play cards with SVC, you have to approve the contract
            as a spender of SVC tokens.
          </span>
        </div>

        <div class="text-muted">
          <span> You only need to give your approval once. </span>
        </div>

        <div class="text-muted">
          <span>
            If you wish to remove your approval, you can do that here, too.
          </span>
        </div>

        <div class="col-12">
          <button
            class="btn btn-success"
            type="button"
            :disabled="playersRewardTokenAllowanceE0 > 0"
            @click="approveRewardToken"
          >
            approve
          </button>
          &nbsp;
          <button
            class="btn btn-danger"
            type="button"
            :disabled="playersRewardTokenAllowanceE0 <= 0"
            @click="removeRewardTokenAllowance"
          >
            (remove approval)
          </button>
        </div>
      </div>
    </div> -->
  </section>

  <div class="popup" v-if="feedbackMessage != '' || txInProgress">
    <div
      class="popupX"
      @click="
        feedbackMessage = '';
        txInProgress = false;
      "
    >
      x
    </div>
    <h4 class="text-monospace animate-popup" v-if="feedbackMessage != ''">
      {{ feedbackMessage }}
    </h4>
    <br />
    <h4 class="text-monospace animate-popup" v-if="txInProgress">
      Please wait for the transaction to finish!
    </h4>
  </div>
</template>

<script>
import { ethers } from "ethers";
import RewardToken from "../../artifacts/contracts/RewardToken.sol/RewardToken.json";
import Cards from "../../artifacts/contracts/Cards.sol/Cards.json";
import Reaper from "../../artifacts/contracts/Reaperville.sol/Reaperville.json";

export default {
  name: "App",
  emits: ["cardsBought"],

  data() {
    return {
      playersAddress: null,
      playersBchBalanceE0: 0,
      playersBalanceE0: {},
      playersRewardTokenAllowanceE0: 0,

      stakingPower: 0,

      ETH: window.ETH,

      contracts: {},

      contractPaused: false,
      remainingCards: 0,
      totalCards: 1215,
      bchPerCardE13: 0,
      tokenPerCardE15: {},
      discounts: [
        0, 0, 10, 1, 20, 2, 40, 3, 80, 4, 150, 5, 250, 6, 500, 7, 750, 8, 1000,
        9, 2500, 10, 10000, 11, 25000, 12,
      ],

      cards2Play: 10,
      maxCardsPerTx: 50,

      show: {},

      feedbackMessage: "",
      txInProgress: false,
    };
  },

  methods: {
    setFeedback: function (_text, _timeOut) {
      let that = this;
      that.feedbackMessage = _text;
      if (that.lastTimeout > 0) {
        clearTimeout(that.lastTimeout);
      }
      if (_timeOut > 0) {
        that.lastTimeout = setTimeout(function () {
          that.feedbackMessage = "";
        }, _timeOut);
      }
    },

    formatNumber: function (_number, _decimals) {
      _number = Number(_number);
      if (_number < 1) {
        return String(_number);
      }

      const _symbols = ["", "k", "M", "G", "T"];
      let returnString = "";
      for (let _idx = _symbols.length - 1; _idx >= 0; --_idx) {
        const _exp = 3 * _idx;
        const _testNumber = _number / 10 ** _exp;
        if (_testNumber >= 1) {
          // get rid off unnecessary decimals
          const _intLength = String(Math.round(_testNumber)).length;
          _number =
            Math.round(_number * 10 ** (_decimals + _intLength + _exp)) /
            10 ** (_decimals + _intLength + _exp);

          returnString =
            Math.floor(_number / 10 ** (_exp - _decimals)) / 10 ** _decimals +
            _symbols[_idx];
          return returnString;
        }
      }
    },

    startGame: function (_totalCostTokenE0) {
      // get tokens won
      console.log("balance old", this.playersBalanceE0["svc"].toString());
      let winningsE0 = this.playersBalanceE0["svc"];
      this.contracts["svc"].balanceOf(this.playersAddress).then((balance) => {
        this.playersBalanceE0["svc"] = ethers.BigNumber.from(balance);
        console.log("balance new", this.playersBalanceE0["svc"].toString());
        winningsE0 = ethers.BigNumber.from(this.playersBalanceE0["svc"])
          .sub(winningsE0)
          .add(_totalCostTokenE0);
        console.log("winningsE0", winningsE0.toString());

        let tokensWonE18 = winningsE0.div(ethers.BigNumber.from(10).pow(18));
        if (tokensWonE18.lt(0) && gameStats > 0) {
          tokensWonE18 = tokensWonE18.sub(1);
        }
        tokensWonE18 = tokensWonE18.toNumber();

        // get game stats
        let gameStats = winningsE0.mod(ethers.BigNumber.from(10).pow(18));
        gameStats = gameStats.toNumber();

        this.$emit("cardsBought", this.cards2Play, tokensWonE18, gameStats);

        // // Deconstruct games
        // console.log(this.extractGameInfo(tokensWonE18, gameStats));

        // console.log("gameStats", gameStats);
        // console.log("SVC won", tokensWonE18);
      });
    },

    playWithToken: async function (_currency) {
      await this.load(); // get most recent values

      // check if there are enough NFTs left to mint as the user wants
      if (this.cards2Play > this.remainingCards) {
        this.feedbackMessage = `There are only ${this.remainingCards} cards available for minting!`;
        this.maxCardsPerTx = this.remainingCards;
        return false;
      }

      // check if the user has enough funds
      let totalCostTokenE15 =
        (this.tokenPerCardE15[_currency] *
          this.cards2Play *
          (100 - this.getDiscount4Reapers(this.stakingPower))) /
        100;
      let totalCostTokenE0 = ethers.utils.parseUnits(
        totalCostTokenE15.toString(),
        15
      );

      // let totalGasLimit = await this.contracts['cards'].estimateGas.playWithToken(
      //   this.cards2Play,
      //   window.ca['svc'],
      //   totalCostTokenWei,
      //   {
      //     gasLimit: 1000000,
      //     gasPrice: 1010000000,
      //   }
      // );
      // console.log(totalGasLimit);

      // totalGasLimit = Math.min(10000000, Math.ceil(totalGasLimit * 1.2));

      const y2 = 1300000;
      const y1 = 135000;
      const x2 = 50;
      const x1 = 1;
      // calculate gas as linear equation
      // gas = m * cards + b
      // m = (y2 - y1) / (x2 - x1)
      // b = (x2 * y1 - x1 * y2) / (x2 - x1)
      let totalGasLimit = Math.min(
        10000000,
        Math.ceil(
          ((y2 - y1) * this.cards2Play) / (x2 - x1) +
            ((x2 * y1 - x1 * y2) / (x2 - x1)) *
              (1 -
                (this.totalCards - this.remainingCards) / (5 * this.totalCards))
        )
      );

      console.log("totalCostTokenE15: ", totalCostTokenE15);
      console.log("Gas limit: ", totalGasLimit);

      // check allowance
      if (this.playersRewardTokenAllowanceE0.lt(totalCostTokenE0)) {
        console.log("allowance", this.playersRewardTokenAllowanceE0.toString());
        console.log("totalCostTokenE0", totalCostTokenE0.toString());

        this.setFeedback("Approving " + _currency + " first", 2000);
        await this.approveRewardToken();
      }

      // check balance
      if (this.playersBalanceE0["svc"].lt(totalCostTokenE0)) {
        console.log("balance", this.playersBalanceE0["svc"].toString());
        console.log("totalCostTokenE0", totalCostTokenE0.toString());
        let _balance = Math.floor(
          ethers.utils.formatEther(this.playersBalanceE0["svc"])
        );
        const _maxCards = Math.round(
          this.playersBalanceE0["svc"].div(
            ethers.utils.parseUnits(this.tokenPerCardE15["svc"].toString(), 15)
          ) - 0.5
        );
        this.setFeedback(
          `You have ${_balance} ${_currency} in your wallet. You can play up to ${_maxCards} cards with that.`,
          2000
        );
        return false;
      }

      // play cards now
      this.setFeedback(`Getting your cards. `, 0);
      this.txInProgress = true;

      let tx;
      try {
        // console.log(
        //   await this.contracts['cards'].callStatic.playWithToken(
        //     this.cards2Play,
        //     window.ca['svc'],
        //     totalCostTokenWei
        //   )
        // );
        tx = await this.contracts["cards"].playWithToken(
          this.cards2Play,
          window.ca["svc"],
          totalCostTokenE0,
          {
            gasLimit: totalGasLimit.toString(),
          }
        );
        // gasPrice: 1046740000,
        await tx.wait();
        // for reading event
        // const rc = await tx.wait();
        // const event = rc.events.find((event) => event.event === "GamesPlayed");
        // const value = event.args;
        // console.log(value);
        if (_currency === "svc") {
          this.startGame(totalCostTokenE0);
        } else {
          this.startGame("0");
        }
      } catch (err) {
        this.setFeedback("An error occured. Please try again later.", 2000);
        this.txInProgress = false;
        return false;
      }

      console.log("tx hash:", tx.hash);
      const txInfo = await this.provider.getTransaction(tx.hash);
      try {
        let code = await this.provider.call(txInfo, txInfo.blockNumber);
        console.log(code);
        if (code == "0x") {
          this.setFeedback(
            `Congratulations! You successfully played some cards!`,
            2000
          );
          this.txInProgress = false;
        }
      } catch (err) {
        this.txInProgress = false;
        const code = err.data.replace("Reverted ", "");
        console.log({ err });
        let reason = ethers.utils.toUtf8String("0x" + code.substr(138));
        console.log("revert reason:", reason);
        this.setFeedback("An error occured. Please try again later.", 2000);
      }
    },

    playWithBCH: async function () {
      await this.load(); // get most recent values

      // check if there are enough NFTs left to mint as the user wants
      if (this.cards2Play > this.remainingCards) {
        this.feedbackMessage = `There are only ${this.remainingCards} cards available for minting!`;
        this.maxCardsPerTx = this.remainingCards;
        return false;
      }

      // check if the user has enough funds
      let totalCostBchE15 =
        this.bchPerCardE13 *
        this.cards2Play *
        (100 - this.getDiscount4Reapers(this.stakingPower));
      let totalCostBchE0 = totalCostBchE15.toString() + "00000000000";

      // let totalGasLimit = await this.contracts['cards'].estimateGas.playWithBch(
      //   this.cards2Play,
      //   {
      //     value: totalCostBchE0,
      //   }
      // );
      // console.log(totalGasLimit);

      // totalGasLimit = Math.min(10000000, Math.ceil(totalGasLimit * 1.2));

      const y2 = 1100000;
      const y1 = 110000;
      const x2 = 50;
      const x1 = 1;
      // calculate gas as linear equation
      // gas = m * cards + b
      // m = (y2 - y1) / (x2 - x1)
      // b = (x2 * y1 - x1 * y2) / (x2 - x1)
      let totalGasLimit = Math.min(
        10000000,
        Math.ceil(
          ((y2 - y1) * this.cards2Play) / (x2 - x1) +
            ((x2 * y1 - x1 * y2) / (x2 - x1)) *
              (1 -
                (this.totalCards - this.remainingCards) / (5 * this.totalCards))
        )
      ); // last term gives a 20% max discount as gas fees are lower the more cards are played

      console.log("totalCostBchE15: ", totalCostBchE15);
      console.log("Gas limit: ", totalGasLimit);

      // check balance
      if (this.playersBchBalanceE0 < Number(totalCostBchE0) + totalGasLimit) {
        this.setFeedback(
          `You have ${
            Math.round(this.playersBchBalanceE0 / 10 ** 14) / 10 ** 4
          } ${this.ETH} in your wallet. You can play up to ${Math.round(
            this.playersBchBalanceE0 / Number(this.bchPerCardE13 * 10 ** 13) -
              0.5
          )} cards with that.`,
          2000
        );
        return false;
      }

      // play cards now
      this.setFeedback(`Getting your cards.`, 0);
      this.txInProgress = true;

      let tx;
      try {
        // console.log(
        //   await this.contracts['cards'].callStatic.playWithBch(
        //     this.cards2Play
        //   )
        // );
        tx = await this.contracts["cards"].playWithBch(this.cards2Play, {
          value: totalCostBchE0,
          gasLimit: totalGasLimit.toString(),
        });
        // gasPrice: 1046740000,
        await tx.wait();
        //  for reading event
        // const rc = await tx.wait();
        // const event = rc.events.find((event) => event.event === "GamesPlayed");
        // const value = event.args;
        // console.log(value);
        this.startGame("0");
      } catch (err) {
        this.setFeedback("An error occured. Please try again later.", 2000);
        this.txInProgress = false;
        return false;
      }

      console.log("tx hash:", tx.hash);
      const txInfo = await this.provider.getTransaction(tx.hash);
      try {
        let code = await this.provider.call(txInfo, txInfo.blockNumber);
        console.log(code);
        if (code == "0x") {
          this.setFeedback(
            `Congratulations! You successfully played some cards!`,
            2000
          );
          this.txInProgress = false;
        }
      } catch (err) {
        this.txInProgress = false;
        const code = err.data.replace("Reverted ", "");
        console.log({ err });
        let reason = ethers.utils.toUtf8String("0x" + code.substr(138));
        console.log("revert reason:", reason);
        this.setFeedback("An error occured.Please try again later.", 2000);
      }

      this.load();
    },

    // extractGameInfo: function (_tokensWon, _gameStats) {
    //   let returnString = "";
    //   if (_tokensWon <= 0) {
    //     returnString =
    //       "Unfortunately, you did not win anything! Better luck next time!";
    //     return returnString;
    //   } else {
    //     returnString = "Congratulations! You won " + _tokensWon + " SVC. \n\n";
    //   }

    //   const modulos = [2057701, 542351, 111701, 16151, 1351, 51, 1];
    //   const payouts = [5000, 2500, 1000, 500, 250, 200, 150];
    //   let w = {};
    //   for (let i = 0; i < modulos.length; ++i) {
    //     w[payouts[i]] = Math.floor(_gameStats / modulos[i]);
    //     _gameStats = _gameStats - modulos[i] * w[payouts[i]];
    //     _tokensWon = _tokensWon - payouts[i] * w[payouts[i]];
    //     returnString +=
    //       w[payouts[i]] > 0 ? w[payouts[i]] + "x " + payouts[i] + " won, " : "";
    //   }
    //   console.log(w);

    //   w[125] = Math.floor(_tokensWon / 125);
    //   returnString += w[125] > 0 ? w[125] + "x " + 125 + " won " : "";

    //   if (_tokensWon - w[125] * 125 !== 0) {
    //     console.log("Calculation did not work");
    //   } else {
    //     console.log("Calculation worked");
    //   }

    //   return returnString;
    // },

    // getDiscount4Reapers: function (_reapers) {
    //   for (let i = 1; i < Math.round(this.discounts.length / 2); i++) {
    //     const idx = 2 * i;
    //     if (_reapers < this.discounts[idx]) {
    //       return this.discounts[idx - 1];
    //     }
    //   }
    //   return this.discounts[this.discounts.length - 1];
    // },

    getDiscount4Reapers: function (_stakingPower) {
      for (let i = 1; i < Math.round(this.discounts.length / 2); i++) {
        const idx = 2 * i;
        if (_stakingPower < this.discounts[idx] * 1000) {
          return this.discounts[idx - 1];
        }
      }
      return this.discounts[this.discounts.length - 1];
    },

    approveRewardToken: async function () {
      let that = this;

      that.setFeedback("Approving EXP token", 0);
      that.txInProgress = true;

      let tx = await that.contracts["svc"].approve(
        window.ca["cards"],
        ethers.constants.MaxUint256,
        {
          gasLimit: 65000, // 60k is probably fine, too
          // gasPrice: 1046740000,
        }
      );
      await tx.wait();
      that.contracts["svc"]
        .allowance(that.playersAddress, window.ca["cards"])
        .then((allowance) => {
          that.playersRewardTokenAllowanceE0 = ethers.BigNumber.from(allowance);
        });
      that.feedbackMessage = "";
      that.txInProgress = false;
    },

    removeRewardTokenAllowance: async function () {
      let that = this;

      that.setFeedback("Removing EXP token approval", 2000);
      that.txInProgress = true;

      let tx = await that.contracts["svc"].approve(window.ca["cards"], 0, {
        gasLimit: 65000, // 60k is probably fine, too
        gasPrice: 1046740000,
      });
      await tx.wait();
      that.contracts["svc"]
        .allowance(that.playersAddress, window.ca["cards"])
        .then((allowance) => {
          that.playersRewardTokenAllowanceE0 = ethers.BigNumber.from(allowance);
        });
      that.feedbackMessage = "";
      that.txInProgress = false;
    },

    setCards2Play: function (_changeAmount) {
      this.feedbackMessage = "";
      this.txInProgress = false;

      this.cards2Play = Math.floor(_changeAmount);
      if (this.cards2Play < 1) {
        this.cards2Play = 1;
      } else if (this.cards2Play > this.maxCardsPerTx) {
        this.cards2Play = this.maxCardsPerTx;
      }
    },

    changeCards2Play: function (_changeAmount) {
      this.feedbackMessage = "";
      this.txInProgress = false;

      this.cards2Play = Math.floor(this.cards2Play) + _changeAmount;
      if (this.cards2Play < 1) {
        this.cards2Play = 1;
      } else if (this.cards2Play > this.maxCardsPerTx) {
        this.cards2Play = this.maxCardsPerTx;
      }
    },

    getBchBalance: function () {
      this.provider.getBalance(this.playersAddress).then((balance) => {
        this.playersBchBalanceE0 = ethers.BigNumber.from(balance);
      });
    },

    getBalance: function (_contractName) {
      // console.log(this.playersAddress);
      this.contracts[_contractName]
        .balanceOf(this.playersAddress)
        .then((balance) => {
          this.playersBalanceE0[_contractName] = ethers.BigNumber.from(balance);
          console.log(
            _contractName,
            this.playersBalanceE0[_contractName].toString()
          );
        });
    },

    getRewardTokenAllowance: function () {
      let that = this;
      that.contracts["svc"]
        .allowance(that.playersAddress, window.ca["cards"])
        .then((allowance) => {
          that.playersRewardTokenAllowanceE0 = ethers.BigNumber.from(allowance);
        });
    },

    loadStakingPower: function () {
      this.contracts["reaper"]
        .showStakerInfo(this.playersAddress)
        .then((stakerInfo) => {
          this.stakingPower = stakerInfo[1];
        });
    },

    load: function () {
      this.feedbackMessage = "";
      this.txInProgress = false;

      this.contracts["cards"]
        .getInfo([window.ca["svc"]])
        .then((paused_remSply_maxSply_dscnt4Rprs_bchE13_tknsE15) => {
          console.log(paused_remSply_maxSply_dscnt4Rprs_bchE13_tknsE15);
          this.contractPaused =
            paused_remSply_maxSply_dscnt4Rprs_bchE13_tknsE15[0] > 0;
          this.remainingCards =
            paused_remSply_maxSply_dscnt4Rprs_bchE13_tknsE15[1];
          this.totalCards = paused_remSply_maxSply_dscnt4Rprs_bchE13_tknsE15[2];
          this.bchPerCardE13 =
            paused_remSply_maxSply_dscnt4Rprs_bchE13_tknsE15[3];
          this.tokenPerCardE15["svc"] =
            paused_remSply_maxSply_dscnt4Rprs_bchE13_tknsE15[4];
        });

      this.signer.getAddress().then((userAddress) => {
        this.playersAddress = userAddress;
        this.getBchBalance();
        this.getBalance("svc");
        // this.getBalance("reaper");
        this.loadStakingPower();
        this.getRewardTokenAllowance();
      });
    },
  },

  mounted: function () {
    this.show["winningChances"] = false;
    this.show["discountDetails"] = false;

    this.provider = new ethers.providers.Web3Provider(window.ethereum, "any");
    this.provider
      .send("eth_requestAccounts", [])
      .then(() => {
        this.signer = this.provider.getSigner();

        this.contracts["svc"] = new ethers.Contract(
          window.ca["svc"],
          RewardToken.abi,
          this.signer
        );

        this.contracts["cards"] = new ethers.Contract(
          window.ca["cards"],
          Cards.abi,
          this.signer
        );

        this.contracts["reaper"] = new ethers.Contract(
          window.ca["reaper"],
          Reaper.abi,
          this.signer
        );
      })
      .then(() => {
        this.load();
      });
  },
};
</script>
